import { EventDispatcher } from './EventDispatcher';

window.addEventListener('resize', () => {
    EventDispatcher.emit('pageResize', { namespace: 'global' });
});
